import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

function Dialog({ mediaType, medias, isPopinOpen, onClose, children }) {
    // On créé une référence pour la popin
    const popinRef = useRef(null);

    // Gestion de la touche Echap pour fermer la popin
    useEffect(() => {
        // On créé la fonction de fermeture de la popin lors de l'appui sur la touche Echap
        const handleEscapeKey = (e) => {
            if (e.keyCode === 27 && isPopinOpen) {
                onClose();
            }
        }

        if (isPopinOpen) document.addEventListener("keydown", handleEscapeKey);

        return () => {
            document.removeEventListener("keydown", handleEscapeKey);
        };
    }, [isPopinOpen, onClose]);

    // Gestion de l'affichage de la popin
    useEffect(() => {
        if (isPopinOpen) {
          popinRef.current?.showModal();
          document.body.style.overflow = "hidden";
        } else {
          popinRef.current?.close();
          document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        }
      }, [isPopinOpen]);

    // Mise en place des références pour cibler le premier élément du menu et le dernier
    // Et de la fonction permettant de réaliser le piège au clavier
    const firstButton = useRef(null);
    const lastButton = useRef(null);
    const handleKeyDown = (e, pos) => {
        if(isPopinOpen && pos === 'first' && e.keyCode === 9 && e.shiftKey === true && lastButton.current !== null) {
            e.preventDefault();
            lastButton.current.focus();
        }
        else if(isPopinOpen && pos === 'last' && e.keyCode === 9 && e.shiftKey === false && firstButton.current !== null) {
            e.preventDefault();
            firstButton.current.focus();
        }
    }

    // Déclaration du titre de la popin
    let popinTitle = (mediaType === 'image') ? 'À propos de cette image' : 'À propos de cette vidéo';

    // Déclaration de l'aria-label du bouton
    let buttonCloseAriaLabel = 'fermeture de la fenêtre interne';

    return (
        <dialog ref={popinRef} className="popin popin--media" aria-labelledby="popin-title">
            <h1
                id="popin-title"
                tabIndex="0"
                autoFocus
                ref={firstButton}
                onKeyDown={(e) => handleKeyDown(e, 'first')}>{popinTitle}</h1>
            <figure className="popin-figure__media-container">
                <picture className="popin-figure__media-picture">
                    <source srcSet={medias.desktop} media="(min-width: 600px)" />
                    <img src={medias.mobile} alt="" />
                </picture>
                <figcaption>
                    {children}
                </figcaption>
            </figure>
            <button
                ref={lastButton}
                className="button button-close button-close--popin-media"
                onClick={onClose}
                onKeyDown={(e) => handleKeyDown(e, 'last')}>
                    <span className="sr-only">{buttonCloseAriaLabel}</span>
            </button>
        </dialog>
    );
}

Dialog.propTypes = {
    mediaType: PropTypes.string.isRequired,
    medias: PropTypes.object.isRequired,
    isPopinOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
}

export default Dialog;
